const regexes = [/郵政信箱/, /郵政.+信箱/];
const getMessage = '不接受郵政信箱';
const validate = (value) => !regexes.some((x) => x.test(value));

/** 自訂檢查郵政信箱驗證規則 */
export default {
  getMessage,
  validate,
};
